// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fT7j","top":"styles_top__24H1x","left":"styles_left__1NrVX","description":"styles_description__1heLY"};